module.exports = __webpack_public_path__ + "img/search.e6426113.svg";